var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"mag-history"},[(_vm.table)?_c('MagHistoryTable',{attrs:{"items":_vm.items}}):_c('MagHistoryTile',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }